const CONFIG = {
  mapbox: {
    token:
      "pk.eyJ1Ijoid3JzdHVkaW9zIiwiYSI6ImNpb25jemduZDAwODZ0cm0yeTNqNDB1ajMifQ.oEcKdETe0pzBDRMon870tQ"
  }
};

export default CONFIG;
